import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { setCurScndCateIdAction } from '../../modules/common/cateModule';

// <div class="aa-top">
const EsApplyProdCateListBlock = styled.div`
    background-color: #fff;
`;

// <ul class="ob_cate-list margin_b-20 clearfix">
const EsApplyUlBlock = styled.ul`
    margin-left: 50px;
    margin-right: 50px;
    margin-bottom: 20px;
    &::after {
        content: '';
        display: block;
        clear: both;
    }
`;

// .tag_s-box .flex-width 
const EsApplyLiBlock = styled.li`
    float: left;
    height: 40px;
    border: 1px solid #ccc;
    border-up
    text-align: center;
    ${props => {
        if (!props.isLeftLine) {
            return `border-left: none`;
        }
        if (props.isNoUpLine) {
            return `border-top: none`;
        }
    }}
`;

// .ob_cate-list li button
const EsApplyLiBtnBlock = styled.button`
    width: 100%;
    height: 100%;
    font-size: 14px;
    ${props => {
        if (!props.active) {
            return `background-color: #fff; color: #999;`;
        } else {
            return `background-color: #ffe7ad; color: #333;`;
        }
    }}
`;

const EsApplyProdCateList = ({ loading, error, cateinfo }) => {

    const dispatch = useDispatch();

    const { curSelCateId } = useSelector(
        ({ cateItemsReducer }) => ({
            curSelCateId: cateItemsReducer.curSelScndCateId
        })
    );

    useEffect(() => {
        if (cateinfo !== null && cateinfo.length > 0) {
            dispatch(setCurScndCateIdAction(cateinfo[0].cateid));
        }
    }, [dispatch, cateinfo]);

    // TODO : Network Error 의 경우 공통 처리 필요 
    if (error) {
        return <EsApplyProdCateListBlock></EsApplyProdCateListBlock>;
    }

    /**
     * 카테고리 선택 했을 경우 Category 2Depth 선택 정보 업데이트 
     * @param {*} cateidx 
     * Redux 에 저장 
     */
    const handleCateClick = (cateid) => {

        // console.log("----->" + cateid);
        dispatch(setCurScndCateIdAction(cateid));
    }

    let cateidx = 0;
    return (
        <EsApplyProdCateListBlock>
            <EsApplyUlBlock>
                {
                    (loading || cateinfo === null) ? (<div />) :
                        (
                            cateinfo.map((cateitem) => {
                                cateidx++;
                                return (
                                    <EsApplyLiBlock key={cateitem.cateid} isLeftLine={(cateidx % 5 === 1) ? true : false} isNoUpLine={cateidx > 5 ? true : false} style={{ width: "20%" }} >
                                        <EsApplyLiBtnBlock type="Button" onClick={() => { handleCateClick(cateitem.cateid) }} active={curSelCateId === cateitem.cateid}>
                                            {cateitem.name}  <span className="font-mont">( {cateitem.cnt} )</span>
                                        </EsApplyLiBtnBlock>
                                    </EsApplyLiBlock>
                                );
                            }))

                }
            </EsApplyUlBlock>
        </EsApplyProdCateListBlock>
    );
};

export default EsApplyProdCateList;